import { formatAmount, signedCount, value } from "../format.ts";
import type { Locale } from "../locale.ts";
import { m } from "../paraglide/messages.js";
import { NEWCOMER_DRIVERS, NEWCOMER_USUAL, NEWCOMER_WEEKS } from "./analytics-demo.ts";

export const percentText = (locale: Locale, share: number): string =>
  formatAmount(locale, value(share, "percent"));

export const NEWCOMERS_NOW = NEWCOMER_WEEKS[NEWCOMER_WEEKS.length - 1]!;

export const readingText = (locale: Locale): string =>
  m.entrance_reading({
    value: percentText(locale, NEWCOMERS_NOW),
    low: percentText(locale, NEWCOMER_USUAL.low),
    high: percentText(locale, NEWCOMER_USUAL.high),
  });

const DRIVER_NAME = {
  channel: () => `#${m.products_findings_demo_channel()}`,
  source: m.products_findings_demo_source,
  role: m.products_leveling_role_newcomer,
} as const;

export const drivers = (locale: Locale): readonly { name: string; points: string }[] =>
  NEWCOMER_DRIVERS.map((driver) => ({
    name: DRIVER_NAME[driver.by](),
    points: m.pulse_delta_points_short({ points: signedCount(locale, driver.points) }),
  }));
